import { useQuery } from "react-query";
import divisionApi from "../utils/api/division";

export function useDivisionUsers(divisionId: number) {
  return useQuery({
    queryKey: ["divisionUsers", divisionId],
    queryFn: () => divisionApi.users.index(divisionId),
  });
}
